module.exports = __webpack_public_path__ + "img/2.19624cc8.png";